import React from "react";
import { useParams } from "react-router-dom";

const MarketingPage = () => {
  const { salespersonId } = useParams(); // Get the salespersonId from the URL

  // Example logic to fetch or generate content for the salesperson
  const fetchMarketingContent = (id) => {
    return `Welcome to the personalized marketing page for Salesperson ID: ${id}!`;
  };

  const content = fetchMarketingContent(salespersonId);

  return (
    <div style={{ padding: "20px", textAlign: "center" }}>
      <h1 style={{ fontSize: "2rem", marginBottom: "1rem"}}>Marketing Page</h1>
      <p style={{ fontsize: "1rem", wordWrap: "break-word"}}>{content}</p>
    </div>
  );
};

export default MarketingPage;